import type { Attachment, OriginalOfDuplicateAttachment } from '../types'

import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

export const checkForDuplicates = async (
  newAttachments: Attachment[]
): Promise<
  PromiseSettledResult<
    | {
        newAttachment: Attachment
        duplicateOf: OriginalOfDuplicateAttachment | null
      }
    | undefined
  >[]
> => {
  return await Promise.allSettled(
    newAttachments.map(async (newAttachment): Promise<
      | {
          newAttachment: Attachment
          duplicateOf: OriginalOfDuplicateAttachment | null
        }
      | undefined
    > => {
      try {
        const duplicateOf = await SFetch.json<OriginalOfDuplicateAttachment>(
          window.Silverfin.Routes.check_for_duplicate_document_path(
            window.Silverfin.currentFirmId,
            window.Silverfin.currentCompanyId,
            {
              q: newAttachment.name,
              s: newAttachment.size,
            }
          )
        )
        return { newAttachment, duplicateOf }
      } catch (error) {
        SfLog.error('Error checking for duplicate document:', { error })
      }
    })
  )
}
